import React, { Component } from "react";
import {
  PieChart,
  Pie,
  Legend,
  Tooltip,
  Cell,
  ResponsiveContainer
} from "recharts";
import Teams from "api/Teams";
import Styled from "components/pm/style";
import { view } from "@risingstack/react-easy-state";

import DecisionsAlert from "./../../../alerts/decisions";

import IconTableHelp from "../../../../containers/assets/icon-table-help.svg";

class DonutPMDecisionsPlacement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoAlert: false,
    };
  }

  showInfoAlert = () => {
    this.setState({
      infoAlert: true
    });
  };

  hideInfoAlert = () => {
    this.setState({
      infoAlert: false
    });
  };

  calculate(type) {
    let products = this.props.products;
    let total = Object.keys(products).length;
    let count = 0;

    if (total === 0) return 0;

    Object.keys(products).forEach(product_id => {
      let product = products[product_id];

      if (product.player !== null && product.client === type) {
        count++;
      }
    });

    return parseFloat(((count / total) * 100).toFixed(2), 10);
  }

  get directSales() {
    return this.calculate(this.props.sales_clients["Direct Sales"]);
  }

  get distributors() {
    return this.calculate(this.props.sales_clients["Distributors"]);
  }

  get data() {
    return [
      {
        name: "Direct Sales",
        value: this.directSales
      },
      {
        name: <Styled.TextWithButton>Distributors <Styled.HelpIcon src={IconTableHelp} onClick={this.showInfoAlert} /></Styled.TextWithButton>,
        value: this.distributors
      }
    ];
  }

  render() {
    const { infoAlert } = this.state;

    return (
      <Styled.P.Chart>
        {infoAlert && (
          <DecisionsAlert
            type="info"
            title="Distributor Cost"
            message="Refers to the estimated cost incurred for selling goods through a middleman."
            buttonText="Done"
            onHide={this.hideInfoAlert}
          />
        )}
        <ResponsiveContainer width="100%" height={150} debounce={500}>
          <PieChart>
            <Legend
              iconType="circle"
              layout="vertical"
              align="right"
              verticalAlign="top"
            />
            <Tooltip formatter={val => `${val}%`} />
            <Pie
              data={this.data}
              cx={63}
              cy={78}
              innerRadius={27}
              outerRadius={63}
              labelLine={true}
              dataKey="value"
            >
              <Cell fill={Teams.directSalesColor()} />
              <Cell fill={Teams.distributorsColor()} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Styled.P.Chart>
    );
  }
}

export default view(DonutPMDecisionsPlacement);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/charts/DonutPMDecisionsPlacement.js